<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="mm_code,mm_name"
      placeholder="输入单据编号、名称进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/production/make_mold/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.mm_code}}</p>
          <p class="list-item-muted">{{item.mm_name}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.mm_custname}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.mm_status=='未审核'}"
          >{{item.mm_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
      <!-- <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('ms_total')}}</em> -->
    </div>
    <add-button to="/production/make_mold_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/makemold/list",
      filters: [
        {
          type: "date",
          name: "make_mold.createTime"
        },
        // {
        //   type: "condition",
        //   label: "状态",
        //   value: -1,
        //   options: [
        //     {
        //       value: -1,
        //       label: "全部",
        //       mode: 'DETAIL',
        //       condition: "pi_class = 'MAKECUTIN'"
        //     },
        //     {
        //       value: 1,
        //       label: "待完工",
        //       mode: 'DETAIL',
        //       condition: "pi_class = 'MAKECUTIN' AND PI_STATUS <> '已审核'"
        //     },
        //     {
        //       value: 2,
        //       label: "已完工",
        //       mode: 'DETAIL',
        //       condition: "pi_class = 'MAKECUTIN' AND PI_STATUS = '已审核'"
        //     }
        //   ]
        // }
      ]
    };
  }
};
</script>